import {useMutation} from '@apollo/react-hooks';

import type {
    SetMicrosoftTeamsIsEnabled as SetMicrosoftTeamsIsEnabledMutation,
    SetMicrosoftTeamsIsEnabledVariables as SetMicrosoftTeamsIsEnabledMutationVariables,
    SetMicrosoftTeamsIsEnabledInput,
    GetTeamsIntegration as GetTeamsIntegrationQuery,
} from 'nutshell-graphql-types';

import SET_MICROSOFT_TEAMS_IS_ENABLED from '../mutations/set-microsoft-teams-is-enabled.graphql';
import GET_TEAMS_INTEGRATION from '../queries/get-teams-integration.graphql';

export function useSetMicrosoftTeamsIsEnabled(): (
    arg1: SetMicrosoftTeamsIsEnabledInput
) => Promise<any> {
    const [setMicrosoftTeamsIsEnabled] = useMutation<
        SetMicrosoftTeamsIsEnabledMutation,
        SetMicrosoftTeamsIsEnabledMutationVariables
    >(SET_MICROSOFT_TEAMS_IS_ENABLED);

    return (input: SetMicrosoftTeamsIsEnabledInput) =>
        setMicrosoftTeamsIsEnabled({
            variables: {input},
            update: (proxy, mutationResults) => {
                const cacheResult: GetTeamsIntegrationQuery | null | undefined = proxy.readQuery({
                    query: GET_TEAMS_INTEGRATION,
                });

                if (!cacheResult || !cacheResult.loggedInUser) {
                    return;
                }

                const updatedMicrosoftTeamsIntegration =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.setMicrosoftTeamsIsEnabled &&
                    mutationResults.data.setMicrosoftTeamsIsEnabled.microsoftTeamsIntegration;

                if (!updatedMicrosoftTeamsIntegration) return;

                proxy.writeQuery({
                    query: GET_TEAMS_INTEGRATION,
                    data: {
                        loggedInUser: {
                            ...cacheResult.loggedInUser,
                            microsoftTeamsIntegration: updatedMicrosoftTeamsIntegration,
                        },
                    },
                });
            },
        });
}
